import { render } from "./Company.vue?vue&type=template&id=753cbb30&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"

import "./Company.vue?vue&type=style&index=0&id=753cbb30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753cbb30"]])

export default __exports__